import React from "react";

import "./SampleData.scss";
import CTAButton from "../CTAButton/CTAButton";

function SampleData(props) {
  return (
    <div
      className="sample-data-fader"
      style={props?.fullWidth ? { width: "100%" } : {}}
    >
      <div className="sample-text-text-holder">
        <h1 id="sample-data-text">Sample Data</h1>

        <CTAButton
          color="pink"
          href="/upgrade"
          text="Upgrade now"
          style={props.ctaStyle}
        ></CTAButton>
      </div>
      <div className="sample-data-children">{props.children}</div>
    </div>
  );
}

export default SampleData;
